'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlTable", function ($print) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: ["tlTable", "?^hideableContainer"],
    template: '' + '<div class="tl-table">' + '   <infini-table table-config="innerTableConfig"></infini-table>' + '</div>',
    link: function link($scope, $element, $attrs, controllers) {
      var ctrl = controllers[0],
        hideableContainerCtrl = controllers[1];
      var unwatch = null;
      $attrs.$observe("tableConfig", function (configName) {
        if (unwatch != null) {
          unwatch();
        }
        $scope.$watch(configName, function (tableConfig) {
          prepareTableConfig(tableConfig);
        });
      });
      function prepareTableConfig(tableConfig) {
        if (tableConfig == null) {
          return;
        }
        var wrappedConfig = _.extend(tableConfig, {
          visibilityManager: hideableContainerCtrl
        });
        if ($print.isPrintEnabled()) {
          wrappedConfig.fullMode = true;
        }
        $scope.innerTableConfig = wrappedConfig;
      }
      $scope.$on("$print:toggle", function (evt, print) {
        var itCtrl = ctrl.getInfiniTableCtrl();
        if (print) {
          itCtrl.enableFullMode();
        } else {
          itCtrl.disableFullMode();
        }
      });
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        infiniTableCtrl = null;
      ctrl.getInfiniTableCtrl = function () {
        if (infiniTableCtrl == null) {
          infiniTableCtrl = $element.find("div.infini-table").controller("infiniTable");
        }
        return infiniTableCtrl;
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tl-table.js
// module id = 3018
// module chunks = 13